(function () {
  'use strict';

  /* @ngdoc object
   * @name exports.exports.delete
   * @description
   *
   */
  angular
    .module('exports.exports.delete', [
      'ui.router'
    ]);
}());
